import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuid4 from 'uuid/v4';
import { absoluteUrl } from '../utils/url';
import { updateMetaData } from '../actions/metaDataActions';
import { setActiveSection, startRouteTransition, endRouteTransition } from '../actions/uiActions';
import { Helmet } from 'react-helmet';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import CSSTransition from 'react-transition-group/CSSTransition';
import Error404 from './Error404';
import Title from './Title';


const Aux = props => props.children;

class Section extends Component {
  constructor (props) {
    super(props);
    this.state = { transitionKey: null };
    this.setMetaData = this.setMetaData.bind(this);
    this.setTransitionKey = this.setTransitionKey.bind(this);
    this.handleTransitionStart = this.handleTransitionStart.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { actions, slug } = this.props;
    this.setMetaData();
    this.setTransitionKey();
    actions.setActiveSection(slug);
  }

  UNSAFE_componentWillReceiveProps (nextProps) { // eslint-disable-line camelcase
    const thisMatch = this.props.routeProps.match;
    const nextMatch = nextProps.routeProps.match;
    const [firstTitle] = this.props.content;
    // Conditionally trigger animation if:
    // - navigating to the root path of a different section, or
    // - navigating from a 'cover' title to another title within the same section
    const isCoverTitle = ['cover', 'grid cover'].includes(firstTitle.type.toLowerCase());
    if (
      (thisMatch.url !== nextMatch.url && nextMatch.isExact) ||
      (thisMatch.isExact !== nextMatch.isExact && isCoverTitle && firstTitle.transition !== false)
    ) {
      // TODO - route transition effect is not rendering well on Safari, so disabled for now.
      // this.setTransitionKey();
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { actions, slug } = this.props;
    if (slug !== prevProps.slug) {
      actions.setActiveSection(slug);
      this.setMetaData();
    }
  }

  componentWillUnmount () {
    this.setMetaData(true);
  }

  handleTransitionStart () {
    const { actions } = this.props;
    actions.startRouteTransition();
  }

  handleTransitionEnd () {
    const { actions } = this.props;
    actions.endRouteTransition();
  }

  setTransitionKey () {
    this.setState({ transitionKey: uuid4() });
  }

  setMetaData (reset = false) {
    const { routeProps: { match }, actions, title, socialImage, description } = this.props;
    const url = absoluteUrl(match.url);
    actions.updateMetaData({
      section: reset ? {} : { title, description, url, image: socialImage },
    });
  }

  renderRoutes () {
    const { routeProps: { match }, content } = this.props;
    const [first, ...rest] = content;
    return [
      ...rest.map(item => (
        <Route key={item.uid} path={`${match.url}/${item.urlSlug}`} render={props => <Title key={item.uid} {...item} />} />
      )),
      <Route key={first.uid} path={match.url} render={props => <Title key={first.uid} {...first} />} />,
      <Route key="error404" component={Error404} />,
    ];
  }

  render () {
    const { routeProps: { location, match }, ui: { routeTransitionsRunning }, content } = this.props;
    const { transitionKey } = this.state;
    // Include hidden links for SEO/prerender crawling
    const titleLinks = content.map((title, i) => {
      const targetUrl = i === 0 ? match.url : `${match.url}/${title.urlSlug}`;
      return <Link key={i} to={targetUrl} />;
    });

    return (
      <TransitionGroup component={Aux}>
        <Helmet>
          {/* Used to apply absolute positioning styles, allowing containers to overlap during the transition */}
          {routeTransitionsRunning > 0 ? <html className="route-transition" /> : null}
        </Helmet>
        <CSSTransition
          key={transitionKey}
          classNames="section-route"
          timeout={200}
          onEnter={this.handleTransitionStart}
          onEntered={this.handleTransitionEnd}
        >
          <div className="section-container">
            <Switch location={location}>
              {this.renderRoutes()}
            </Switch>
            <div className="d-none">{titleLinks}</div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

Section.propTypes = {
  title: PropTypes.string,
  slug: PropTypes.string,
  description: PropTypes.string,
  order: PropTypes.number,
  content: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = ({ ui }) => ({ ui });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateMetaData, setActiveSection, startRouteTransition, endRouteTransition }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Section);



// WEBPACK FOOTER //
// ./src/components/Section.js